/* eslint-disable @repo/internal/react/require-jsdoc */

import React from 'react';

import { token } from '@atlaskit/tokens';

export const UppercaseI = (): React.JSX.Element => (
	<svg width="30" height="11" viewBox="0 0 30 11" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M1.5293 0.814453V11H0.230469V0.814453H1.5293ZM14.2168 10.3643L13.4238 9.57129L14.8662 8.13574C15.0439 7.96257 15.2376 7.78255 15.4473 7.5957C15.6615 7.4043 15.8825 7.21517 16.1104 7.02832C16.3382 6.83691 16.557 6.6569 16.7666 6.48828C16.9808 6.31966 17.1768 6.16927 17.3545 6.03711L17.1631 6.25586C16.9762 6.29232 16.7871 6.32878 16.5957 6.36523C16.4089 6.39714 16.2197 6.42448 16.0283 6.44727C15.8415 6.46549 15.6523 6.47461 15.4609 6.47461H8.44727V5.33984H15.4609C15.6523 5.33984 15.8415 5.35124 16.0283 5.37402C16.2197 5.39225 16.4089 5.41732 16.5957 5.44922C16.7871 5.48112 16.9762 5.51758 17.1631 5.55859L17.3545 5.77734C17.1221 5.59961 16.8555 5.39225 16.5547 5.15527C16.2585 4.91374 15.9622 4.66536 15.666 4.41016C15.3698 4.15495 15.1032 3.91113 14.8662 3.67871L13.4238 2.24316L14.2168 1.4502L18.6738 5.90723L14.2168 10.3643ZM24.6211 11V9.85156H26.4326V1.96289H24.6211V0.814453H29.5361V1.96289H27.7314V9.85156H29.5361V11H24.6211Z"
			fill={token('color.text')}
		/>
	</svg>
);
